import { httpApi } from '@api/http.api';
import type { AdminCenterValidationResponse } from '@routes/sidebar/admin-center/tenant-client/api/adminCenterValidation.types.ts';
import type { CommonSearchRequest, PaginatedResponse } from '@types';

export type AdminCenterClientsQuery = CommonSearchRequest;

export interface AdminCenterClientTenant {
    id: number;
    name: string;
    alias: string;
    active: boolean;
    canBeActivated: boolean;
    tenantType: string;
    dateModified: string | null;
    subscriptions: number | null;
    learning: number | null;
    assessment: number | null;
}

export interface AdminCenterClient {
    id: number;
    name: string;
    tenants: AdminCenterClientTenant[];
}

export interface TotalTenantsFound {
    totalTenants: number;
}
export type AdminCenterClientsResponse = PaginatedResponse<AdminCenterClient, TotalTenantsFound>;

export interface AdminCenterTenantActiveStatusPayload {
    isActive: boolean;
}

export const getApiAdminCenterClients = (payload: AdminCenterClientsQuery): Promise<AdminCenterClientsResponse> =>
    httpApi.post<AdminCenterClientsResponse>('admin-center/clients/search', payload).then(({ data }) => data);

export const getApiAdminCenterValidation = (): Promise<AdminCenterValidationResponse> =>
    httpApi.get<AdminCenterValidationResponse>('admin-center/validation/entities').then(({ data }) => data);

export const updateTenantActiveStatus = (
    clientId: number,
    tenantAlias: string,
    payload: AdminCenterTenantActiveStatusPayload,
): Promise<void> =>
    httpApi
        .patch<void>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/active-status`, payload)
        .then(({ data }) => data);

export const deleteTenant = (clientId: number, tenantAlias: string): Promise<void> =>
    httpApi.delete<void>(`admin-center/clients/${clientId}/tenants/${tenantAlias}`).then(({ data }) => data);
